import React from "react";
import { SvgIcon } from "@mui/material";

export default function SelectArrow(props) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 10 5"
      sx={{ width: 10, height: 5, mr: 0.5, ...props?.sx }}
    >
      <path d="M0 0L5 5L10 0H0Z" fill="#0DA3E2" />
    </SvgIcon>
  );
}
